<script>
  import Viedo from '@components/List/News'

  export default {
    components: {
      Viedo
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    computed: {
      formattedTopList() {
        return this.list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introtext: item.introtext,
          brands: item.brands[0],
          to: {
            name: 'video-item',
            params: {
              brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
              categoryAlias: item.category_alias,
              videoAlias: item.alias,
            },
          },
          videoId: this.youtubeId(item.extrafields.youtube_url.value)
          // isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
    },
    methods: {
      youtubeId(id) {

        if(id) {
          const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          const match = id.match(regExp);
          return (match && match[7].length === 11)
            ? match[7]
            : false;
        }

        return '';
      },
      // formattedVideoId(id) {
      //   if(id.includes('=')){
      //     return id.split('=')[1]
      //   }else {
      //     return id.split('/')[id.split('/').length - 1]
      //   }
      // },
    }
  }
</script>
<template>
  <div :class="$style.SectionRowItem" class="section bg-gray-2">
    <div class="container">
      <Viedo
        is-row-item
        is-video
        :list="formattedTopList"
        link-type="list"
        content-type="video"
      />
    </div>
  </div>
</template>
<style lang="scss" module>
  .SectionRowItem {
    // background-color: $color-gray-2;
  }
</style>
